module.exports = __webpack_public_path__ + "img/auto.ef34d620.png";